import { jsx as l } from "react/jsx-runtime";
const n = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m12.225 6.05.45 1.67-3.62 3.62-1.06 1.06-1.06-1.06-3.61-3.61.45-1.675 3.47 3.475V1.9l1.5-.4v8.03l3.48-3.48ZM14.5 14.5l-.405-1.5H1.5l.405 1.5H14.5Z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  n as Download
};
